import {Observable, Subject} from 'rxjs';
import {Injectable} from '@angular/core';
import {ProTasksPreviewEntry} from './model/pro-tasks-preview.entry';
import {LastDoneProTaskEntry} from './model/last-done-pro-task.entry';
import {MapPosition} from '../../route/metamodel';

@Injectable({
  providedIn: 'root'
})
export class ProTasksQueueStateService {

  private taskDataSource = new Subject<any>();
  private taskDatas$ = this.taskDataSource.asObservable();

  private previewTaskPolylineSource = new Subject<ProTasksPreviewEntry>();
  private previewTaskPolylines$ = this.previewTaskPolylineSource.asObservable();

  private removeTaskPolylineSource = new Subject<string>();
  private removeTaskPolylines$ = this.removeTaskPolylineSource.asObservable();

  private drawVehicleMarkerSource = new Subject<number>();
  private drawVehicleMarker$ = this.drawVehicleMarkerSource.asObservable();

  private lastDoneTaskMarkerSource = new Subject<LastDoneProTaskEntry>();
  private lastDoneTaskMarker$ = this.lastDoneTaskMarkerSource.asObservable();

  private highlightTaskSource = new Subject<string>();
  private highlightTask$ = this.highlightTaskSource.asObservable();

  private removeTaskHighlightSource = new Subject<void>();
  private removeTaskHighlight$ = this.removeTaskHighlightSource.asObservable();

  private taskZoomSource = new Subject<any>();
  private taskZoom$ = this.taskZoomSource.asObservable();

  private reloadQueueSource = new Subject<boolean>();
  private reloadQueue$ = this.reloadQueueSource.asObservable();

  constructor() {
  }

  public taskData(data: any): void {
    this.taskDataSource.next(data);
  }

  public taskDatas(): Observable<any> {
    return this.taskDatas$;
  }

  public previewTaskPolyline(data: ProTasksPreviewEntry): void {
    this.previewTaskPolylineSource.next(data);
  }

  public previewedTaskPolyline(): Observable<ProTasksPreviewEntry> {
    return this.previewTaskPolylines$;
  }

  public clearTaskPolyline(uuid: string): void {
    this.removeTaskPolylineSource.next(uuid);
  }

  public clearedTaskPolyline(): Observable<string> {
    return this.removeTaskPolylines$;
  }

  public drawVehicleMarker(data: any): void {
    this.drawVehicleMarkerSource.next(data);
  }

  public drawnVehicleMarker(): Observable<any> {
    return this.drawVehicleMarker$;
  }

  public triggerLastDoneTask(data: LastDoneProTaskEntry) {
    this.lastDoneTaskMarkerSource.next(data);
  }

  public lastDoneTask(): Observable<LastDoneProTaskEntry> {
    return this.lastDoneTaskMarker$;
  }

  public triggerTaskHighlight(data: string) {
    this.highlightTaskSource.next(data);
  }

  public highlightTask(): Observable<string> {
    return this.highlightTask$;
  }

  public triggerRemoveTaskHighlight() {
    this.removeTaskHighlightSource.next();
  }

  public removeTaskHighlight(): Observable<void> {
    return this.removeTaskHighlight$;
  }

  public triggerTaskZoom(data: MapPosition) {
    this.taskZoomSource.next(data)
  }

  public taskZoom(): Observable<MapPosition> {
    return this.taskZoom$;
  }

  public reloadQueue(data: boolean)  {
    this.reloadQueueSource.next(data)
  }

  public reloadQueueView(): Observable<boolean> {
    return this.reloadQueue$;
  }
}
